export interface HomeFaq {
  number: string;
  question: string;
  answer: string;
}

export const homeFaqs: HomeFaq[] = [
  {
    number: "01",
    question: "O que é um sistema de gestão de eventos?",
    answer:
      "Um sistema de gestão de eventos é um software que centraliza todas as etapas da operação de um buffet ou empresa de eventos: captação de leads, criação de propostas, mensagens no WhatsApp, contratos, pagamentos, agenda e relacionamento com clientes. Em vez de controlar tudo em planilhas, WhatsApp e papel, você acompanha cada evento em um só lugar — do primeiro contato ao pós-festa. Aqui você simplifica todo o processo que hoje você faz na mão.",
  },
  {
    number: "02",
    question: "Como confecciono minha Proposta Digital?",
    answer:
      "Você cadastra seus cardápios, produtos, fotos e regras comerciais na AmeUp. A plataforma calcula os valores e gera um link de proposta pronto para compartilhar com o cliente.",
  },
  {
    number: "03",
    question: "Como funciona o Pagamento Online da AmeUp?",
    answer:
      "O cliente pode pagar pelo link da proposta com PIX ou cartão. O pagamento fica vinculado ao evento e pode ser acompanhado pelo fornecedor no painel.",
  },
  {
    number: "04",
    question: "Para quem a AmeUp funciona?",
    answer:
      "A AmeUp funciona para o dono de buffet que quer crescer, mas ainda faz tudo na mão — proposta, cobrança, contrato, agenda — e já entendeu que sem gestão organizada o crescimento não acontece.",
  },
  {
    number: "05",
    question: "A AmeUp ajuda a acompanhar as vendas?",
    answer:
      "Sim. O CRM e o funil mostram cada oportunidade, o histórico do cliente e a etapa da negociação, desde a proposta até o fechamento do evento.",
  },
  {
    number: "06",
    question: "Onde posso compartilhar a Proposta Digital?",
    answer:
      "O link pode ser compartilhado por WhatsApp, Instagram, e-mail ou qualquer outro canal usado pelo buffet para atender seus clientes.",
  },
];